var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPdfIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5054_130356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.834 1.08301H4.33398C3.73815 1.08301 3.25065 1.57051 3.25065 2.16634V8.66634C3.25065 9.26217 3.73815 9.74967 4.33398 9.74967H10.834C11.4298 9.74967 11.9173 9.26217 11.9173 8.66634V2.16634C11.9173 1.57051 11.4298 1.08301 10.834 1.08301ZM6.22982 5.14551C6.22982 5.59509 5.8669 5.95801 5.41732 5.95801H4.87565V7.04134H4.06315V3.79134H5.41732C5.8669 3.79134 6.22982 4.15426 6.22982 4.60384V5.14551ZM8.93815 6.22884C8.93815 6.67842 8.57523 7.04134 8.12565 7.04134H6.77148V3.79134H8.12565C8.57523 3.79134 8.93815 4.15426 8.93815 4.60384V6.22884ZM11.1048 4.60384H10.2923V5.14551H11.1048V5.95801H10.2923V7.04134H9.47982V3.79134H11.1048V4.60384ZM4.87565 5.14551H5.41732V4.60384H4.87565V5.14551ZM2.16732 3.24967H1.08398V10.833C1.08398 11.4288 1.57148 11.9163 2.16732 11.9163H9.75065V10.833H2.16732V3.24967ZM7.58398 6.22884H8.12565V4.60384H7.58398V6.22884Z",
    fill: "#19305A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5054_130356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPdfIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pdfIcon.3119b381.svg";
export { ForwardRef as ReactComponent };